import { render, staticRenderFns } from "./RemarkEditor.vue?vue&type=template&id=a876bb60&scoped=true&"
import script from "./RemarkEditor.vue?vue&type=script&lang=js&"
export * from "./RemarkEditor.vue?vue&type=script&lang=js&"
import style0 from "./RemarkEditor.vue?vue&type=style&index=0&id=a876bb60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a876bb60",
  null
  
)

export default component.exports